export function initHeaderInteractions() {
    const menuBtn   = document.querySelector('#headeroptions .option.menu');
    const searchBtn = document.querySelector('#headeroptions .option.search');
    const mainnav   = document.getElementById('mainnav');
    const searchBox = document.getElementById('search');
    const darken    = document.getElementById('darken');
    const header    = document.getElementById('header');

    if (!menuBtn || !searchBtn || !mainnav || !searchBox || !header) return;

    function blockScroll(active) {
        document.body.classList.toggle('noscroll', active);
        if (darken) darken.classList.toggle('active', active);
        header.classList.toggle('forceshow', active);
    }

    menuBtn.addEventListener('click', () => {
        const isActive = mainnav.classList.toggle('active');
        menuBtn.classList.toggle('active', isActive);
        searchBox.classList.remove('active');
        searchBtn.classList.remove('active');
        blockScroll(isActive);
    });

    searchBtn.addEventListener('click', () => {
        const isActive = searchBox.classList.toggle('active');
        searchBtn.classList.toggle('active', isActive);
        mainnav.classList.remove('active');
        menuBtn.classList.remove('active');
        blockScroll(isActive);
        if (isActive) searchBox.querySelector('input')?.focus();
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            mainnav.classList.remove('active');
            searchBox.classList.remove('active');
            menuBtn.classList.remove('active');
            searchBtn.classList.remove('active');
            blockScroll(false);
        }
    });
}
